import React from "react";
import Header from "./Header";

import Hero from "./Hero";

import HomeCourses from "./HomeCourses";
import Feedback from "./Feedback";
import WhyUs from "./WhyUs";
import Pricing from "./Pricing";
import Faq from "./Faq";
import Footer from "./Footer";

function Home() {
  return <div>
    {/* <Header/> */}
    <Hero/>
    <HomeCourses/>
    <Feedback/>
    <WhyUs/>
    <Pricing/>
    <Faq/>
    <Footer/>
    
    
    {/* <TensesPage/> */}
  </div>;
}

export default Home;
